<button id="work-packages-settings-button"
        [title]="text.more_actions"
        class="button last work-packages-settings-button toolbar-icon"
        opSettingsContextMenu
        opSettingsContextMenu-query="query"
        [hideTableOptions]="hideTableOptions"
        [showCalendarSharingOption]="showCalendarSharingOption">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" class="button--icon">
    <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>
    <circle cx="5.2" cy="8" r="1" fill="currentColor"/>
    <circle cx="8" cy="8" r="1" fill="currentColor"/>
    <circle cx="10.8" cy="8" r="1" fill="currentColor"/>
  </svg>
</button>
